import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { ValidateId } from "../id-validator";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PhoneNumberComponent } from '../phone-number/phone-number.component';
import { Lead } from "../interfaces/lead";
import { LeadService } from "../services/lead.service";
import { ModalWindowComponent } from '../modal-window/modal-window.component';

@Component({
  selector: 'app-help-dialog-recycle',
  templateUrl: './help-dialog-recycle.component.html',
  styleUrls: ['./help-dialog-recycle.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class HelpDialogRecycleComponent implements OnInit {
  user: FormGroup;
  errorMessage: string;
  submitted;
  isMobilePhone: boolean;
  advisorData: any;
  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private leadService: LeadService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.errorMessage = "";
    this.createForm();
    this.setValidators();
  }
  createForm() {
    this.user = this.fb.group({
      firstName: '',
      lastName: '',
      idNumber: '',
      phoneNumber: ''
    });
  }
  updateValidators(event) {
    this.setValidators();
  }
  validatePhone(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.value.includes("בחר")) {
        return {
          required: true
        };
      }
      if (this.isMobilePhone && control.value && control.value.length < 10) {
        return {
          minlength: true
        };
      } else if (!this.isMobilePhone && control.value && control.value.length < 9) {
        return {
          minlength: true
        };
      }
    };
  }
  setValidators() {
    this.submitted = false;
    this.user.controls["firstName"].setValidators([Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")]);
    this.user.controls["lastName"].setValidators([Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")]);
    this.user.controls["idNumber"].setValidators([Validators.required, ValidateId]);
    this.user.controls["phoneNumber"].setValidators([Validators.required, this.validatePhone(), Validators.pattern("^[0-9]*$")]);
  }
  onSubmit({ value, valid }: { value: any, valid: boolean }) {

    console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>  onSubmit", value);
    this.submitted = true;
    
    
    if (valid) {
    const phoneSufixPose = value.phoneNumber.length - 7;

    let phoneAdvisorSufixPose = 0;
    if (this.advisorData && this.advisorData.phoneAdvisorNumber) {
      phoneAdvisorSufixPose = this.advisorData.phoneAdvisorNumber.length - 7;
    }


      let lead: Lead = {
        campaign_code: '1074',
        first_name: value.firstName,
        last_name: value.lastName,
        Id: value.idNumber,
        id_type: '1',
        phone_1_prefix: value.phoneNumber.substring(0, phoneSufixPose),
        phone_1_number: value.phoneNumber.substring(phoneSufixPose, value.phoneNumber.length),
        is_advisor: this.advisorData && this.advisorData.isAdvisor ? '1' : "",
        first_name_advisor: this.advisorData && this.advisorData.firstNameAdvisor ? this.advisorData.firstNameAdvisor : null,
        phone_advisor_prefix: this.advisorData && this.advisorData.phoneAdvisorNumber? this.advisorData.phoneAdvisorNumber.substring(0, phoneAdvisorSufixPose) : null, 
        phone_advisor_number: this.advisorData && this.advisorData.phoneAdvisorNumber? this.advisorData.phoneAdvisorNumber.substring(phoneAdvisorSufixPose) : null
        };

      this.leadService.resetGuid();
      this.leadService.sendLead(lead, true, false).subscribe(
        (response) => {
          const isAdvisor = lead.is_advisor === '1'; // Convert to boolean
          const isFail = response.isFail === true;
          
          this.activeModal.close('Close click');
  
          const modalRef = this.modalService.open(ModalWindowComponent);
          modalRef.componentInstance.isAdvisor = isAdvisor; 
          modalRef.componentInstance.isFail = isFail; 
        },
  
        (error) => {
          console.error("Failed to send lead:", error);
          this.errorMessage = "שירות זה אינו זמין ברגע זה. נא לנסות מאוחר יותר";
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/help-dialog-recycle/help-dialog-recycle.component.ts